import {texture} from "p3";
import definitions from "../../../definitions";
import Item from "./Item";

export default class ItemTurnipCubes extends Item {
    constructor() {
        super(definitions.ITEM_ID.TURNIP_CUBES, texture("prop_turnip_cubes_00"));
    }

    init() {
        super.init();

        this.addShadow(definitions.SHADOW_SIZE.SMALL, 0.6, new PIXI.Point(3, 0));
    }
}